import { demoFile, component, componentWithVariants, variant, story, CLICK, POPUP } from 'system/demo';
import { ModDashboardUserProfileInformation, ModDashboardUserStatistics } from 'open-modules/zdf/component/moddashboard/moddashboarduserprofile';
const modDashboardDemoData = {
  demoAuthors: {
    a: { key: 'a' },
    c: { key: 'c' },
    d: { key: 'd' },
  },
  modTaskQueues: { thread1: {} },
  serverCalls: {},
};

demoFile('open-modules/zdf/component/moddashboard/moddashboarduserprofile');

const userProfileDataNoEntries = {
  commentCount: 0,
  rejectedCommentCount: 0,
  flagsGivenCount: 0,
  flagsReceivedCount: 0,
  suspension: { warnings: {} },
};

const userProfileDataOneEntry = {
  commentCount: 1,
  rejectedCommentCount: 1,
  flagsGivenCount: 1,
  flagsReceivedCount: 1,
  suspension: { warnings: { w: {} } },
};

const userProfileDataMultipleEntries = {
  commentCount: 2,
  rejectedCommentCount: 2,
  flagsGivenCount: 2,
  flagsReceivedCount: 2,
  suspension: { warnings: { w1: {}, w2: {} } },
};

component('ModDashboardUserProfileInformation', ModDashboardUserProfileInformation, {
  args: { userId: modDashboardDemoData.demoAuthors.a.key },
  state: { serverCall: modDashboardDemoData.serverCalls },
});

componentWithVariants('ModDashboardUserStatistics', ModDashboardUserStatistics, {}, [
  variant('No entries', { args: { userProfileData: userProfileDataNoEntries } }),
  variant('One entry', { args: { userProfileData: userProfileDataOneEntry } }),
  variant('Multiple entries', { args: { userProfileData: userProfileDataMultipleEntries } }),
]);

componentWithVariants('ModDashboardUserProfileInformation (actions)', ModDashboardUserProfileInformation, {
  state: {
    serverCall: modDashboardDemoData.serverCalls,
    modulePublic: { moderation: { queue: modDashboardDemoData.modTaskQueues.thread1 } },
  },
}, [
  variant('Blockable user', { args: { userId: modDashboardDemoData.demoAuthors.c.key } }),
  variant('Blocked user', { args: { userId: modDashboardDemoData.demoAuthors.d.key } }),
]);
